import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue-next';
import template from './time.vdt';
import { useState } from '../../hooks/useState';
import { bind } from '../utils';
import { getNowDate } from './helpers';
import { useConfigContext } from '../config';
var defaultValue = {
  h: 0,
  m: 0,
  s: 0
};
export var DatepickerTime = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DatepickerTime, _Component);
  function DatepickerTime() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.value = useState(defaultValue);
    _this.disabled = useDisable(_assertThisInitialized(_this));
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = DatepickerTime.prototype;
  _proto.init = function init() {
    var _this2 = this;
    this.watch('value', function (v) {
      _this2.value.set(v ? {
        h: v.hour(),
        m: v.minute(),
        s: v.second()
      } : defaultValue);
    });
  };
  _proto.changeHour = function changeHour(v) {
    this.changeValue(v, 'h');
  };
  _proto.changeMinute = function changeMinute(v) {
    this.changeValue(v, 'm');
  };
  _proto.changeSecond = function changeSecond(v) {
    this.changeValue(v, 's');
  };
  _proto.changeValue = function changeValue(v, type) {
    var value = this.get('value') || getNowDate();
    this.set('value', value.set(type, v));
  };
  return DatepickerTime;
}(Component);
DatepickerTime.template = template;
__decorate([bind], DatepickerTime.prototype, "changeHour", null);
__decorate([bind], DatepickerTime.prototype, "changeMinute", null);
__decorate([bind], DatepickerTime.prototype, "changeSecond", null);
var hourRegExp = /h/i;
var secondRegExp = /s/;
var minuteRegExp = /m/;
function useDisable(instance) {
  var disableSeconds = useState(false);
  var disableMinutes = useState(false);
  var disableHours = useState(false);
  instance.on('$receive:format', function (format) {
    disableSeconds.set(!secondRegExp.test(format));
    disableMinutes.set(!minuteRegExp.test(format));
    disableHours.set(!hourRegExp.test(format));
  });
  function disableItem(v, type) {
    var _instance$get = instance.get(),
      value = _instance$get.value,
      isDisabledTime = _instance$get.isDisabledTime,
      flag = _instance$get.flag;
    if (!value) return false;
    value = value.set(type, v);
    return isDisabledTime(value, flag);
  }
  return {
    disableSeconds: disableSeconds,
    disableMinutes: disableMinutes,
    disableHours: disableHours,
    disableItem: disableItem
  };
}